import axios from ".";
/** Search people records by filters. */
export const getPeople = (params: any) => {
  return axios({
    method: "POST",
    url: `/employees/search`,
    data: params,
  });
};
/** Search people for role management. */
export const getPeopleForRoles = (params: any) => {
  return axios({
    method: "POST",
    url: `/employees/search-all`,
    data: params,
  });
};
/** Search objectives. */
export const getObjectives = (params: any) => {
  return axios({
    method: "POST",
    url: `/objective`,
    params,
    data: {
      status: null,
      departments: null,
    },

  });
};
/** Search initiatives. */
export const getInitiatives = (params: any) => {
  return axios({
    method: "POST",
    url: `/initiative`,
    params,
    data: {
      status: null,
      departments: null,
    },
  });
};
/** Search milestones by search text. */
export const getMilestones = (params: any) => {
  return axios({
    method: "GET",
    url: `/milestone/search-bar`,
    params: { searchText: params.searchText },
  });
};
/** Search key results. */
export const getKeyResults = (params?: any) => {
  return axios({
    method: "GET",
    url: `/key-results/search-bar`,
    params,
  });
};
/** Check if a user can be disabled based on assignments. */
export const disableUser = (employeeId: number) => {
  return axios({
    method: "GET",
    url: `/employees/hasAssignments?employeeId=${employeeId}`,
  });
};
